const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
    listaUnidade: [],
    listaVeiculo: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'EQUIPAMENTO_ALOCACAO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'EQUIPAMENTO_ALOCACAO_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'EQUIPAMENTO_ALOCACAO_UNIDADE_SELECT_LISTADO':
			return {
				...state,
				listaUnidade: action.payload.data
            };

        case 'EQUIPAMENTO_ALOCACAO_VEICULO_SELECT_LISTADO':
			return {
				...state,
				listaVeiculo: action.payload.data
            };
                      
        default:
            return state;
    }
}
